import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";
import { ViewEstimatesRequestedListModal } from './Modal_Estimates_Requested';
import { ViewActiveProjectsListModal } from './Modal_Active_Projects';

import {DateRange} from './DateRange'


export function ProjectsSlides(props) {


    let authClient_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authClient_context.acctID);
    //alert(authClient_context.accessRights);
    //alert(authClient_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate()-30)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [numOfEstimatesRequested, setNumOfEstimatesRequested] = useState(0);
    let [numOfActiveProjects, setNumOfActiveProjects] = useState(0);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [viewEstimatesRequestedListModal, setViewEstimatesRequestedListModal] = useState(false);
    let [viewActiveProjectsListModal, setViewActiveProjectsListModal] = useState(false);

    let [notifications, setnotifications] = useState([]);

    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }



    function reloadDates(event)
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: "74100_projectsOverview",
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {


            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setNumOfEstimatesRequested(cols[0]);
                    setNumOfActiveProjects(cols[1]);

                }
        
                authClient_context.changeStartDateRange(event[0]);
                authClient_context.changeEndDateRange(event[1]);
        })

    }
    //alert('In CheckInCheckOut');
    //alert(notifications);
    //alert(notifications.length);
    //alert(authClient_context.accessRights[0]);
    useEffect(() => {
        
        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

    return (

        <IonContent>
            {notifications.length !== 0 &&
            <IonList>
                {notifications.map((notif) =>
                    <IonItem key={notif.id}>
                        <IonLabel>
                            <IonText>
                                <h3 className="notif-title">{notif.title}</h3>
                            </IonText>
                            <p>{notif.body}</p>
                        </IonLabel>
                    </IonItem>
                )}
                </IonList>}
            <IonItem>
                <IonGrid>
                    <DateRange setDate={(e) => reloadDates(e)} data={{
                        startDate: startDate, 
                        endDate: endDate
                        }}></DateRange>
                </IonGrid>
            </IonItem>
            <IonGrid >
                <IonRow>
                    <IonCol>
                        <h3>Estimates Requested</h3>
                        <p > {numOfEstimatesRequested} </p>
                        <IonButton onClick={() => setViewEstimatesRequestedListModal(true)}> View </IonButton>
                    </IonCol>
                    <IonCol>
                        <h3>Active Projects</h3>
                        <p > {numOfActiveProjects} </p>
                        <IonButton onClick={() => setViewActiveProjectsListModal(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>


            {viewEstimatesRequestedListModal == true && <ViewEstimatesRequestedListModal openModal={ viewEstimatesRequestedListModal } closeModal={() => setViewEstimatesRequestedListModal(false)} startDate={startDate} endDate={endDate}></ViewEstimatesRequestedListModal>}

            {viewActiveProjectsListModal == true && <ViewActiveProjectsListModal openModal={ viewActiveProjectsListModal } closeModal={() => setViewActiveProjectsListModal(false)} startDate={startDate} endDate={endDate}></ViewActiveProjectsListModal>}

        </IonContent>

    )
    //}   
}